import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMessage } from "../../Types/Message";

export interface MessagesState {
    locator: string;
    first_name: string;
    last_name: string;
}

const initialState = {
    locator: '',
    first_name: '', 
    last_name: ''
}
export const messagesSlice = createSlice({
    name: 'Messages',
    initialState,
    reducers: {
        reset() {
            return initialState;
        },
        setConversation(state, action: PayloadAction<MessagesState>) {
            state = action.payload;
        },
    }
})

export const {
    reset,
    setConversation
} = messagesSlice.actions

export default messagesSlice.reducer

